<template>
    <div class="basket-item d-flex flex-column flex-lg-row justify-content-lg-between">
        <div class="basket-item-top d-flex">
            <figure class="basket-item-figure align-self-start">
                <img
                    v-if="item.image_url"
                    src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                    data-sizes="auto"
                    :data-src="responsiveImagesLast"
                    :data-srcset="responsiveImages"
                    class="image-responsive lazyload lazyload-animate"
                    :alt="item.title"
                >
            </figure>
            <div class="basket-item-content d-flex flex-column">
                <p class="basket-item-subtitle">{{ item.subtitle }}</p>
                <p class="basket-item-title">{{ item.title }}</p>
                <p
                    v-for="variant_meta in item.variant_metas"
                    class="basket-item-note mt-1"
                >
                    {{ variant_meta.value }}
                </p>
                <p class="basket-item-note mt-1">{{ $t('basket.count') }}: {{ item.quantity }}</p>
            </div>
        </div>
        <div class="basket-item-bottom d-flex justify-content-end">
            <div class="price price-large d-flex flex-column-reverse align-items-end">
                <span
                    v-if="item.price.old"
                    class="price-old"
                >
                    <span v-if="isBusinessUser">
                        {{ item.priceExcTotal.old | currency }}
                    </span>
                    <span v-else>
                        {{ item.priceTotal.old | currency }}
                    </span>
                </span>

                <span v-if="isBusinessUser">
                    {{ item.priceExcTotal.amount | currency }}
                </span>
                <span v-else>
                    {{ item.priceTotal.amount | currency }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import cdn from '@23g/cdn-helper';

    export default {
        name: 'CheckoutSummaryItem',
        data() {
            return {
                imageWidths: [
                    'h360',
                    'h720',
                ],
            };
        },
        props: {
            item: {
                required: true,
                type: Object,
            },
        },
        computed: {
            responsiveImagesLast() {
                return cdn(this.item.image_url, 'h720');
            },

            responsiveImages() {
                return this.generateImageSizes(this.item.image_url, this.imageWidths);
            },
        },
    };
</script>
